import { type ReactElement } from 'react'
import { Typography, TypographyProps } from '@mui/material'

type TimerProps = {
  seconds?: number
} & TypographyProps

export function Timer({
  seconds,
  ...typographyProps
}: TimerProps): ReactElement {
  return (
    <Typography variant="body3.500" {...typographyProps}>
      {seconds !== undefined
        ? `${Math.floor(seconds / 60)
            .toString()
            .padStart(2, '0')}:${String(Math.round(seconds % 60)).padStart(
            2,
            '0'
          )}`
        : '--:--'}
    </Typography>
  )
}
